import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import NoEntriesIcon from '@material-ui/icons/SentimentVerySatisfiedOutlined';
import { withStyles } from '@material-ui/core/styles';
import Order from './order';
import { caseInsensitiveMatch } from '../../utils/case-insensitive-match';


class OrderGrid extends Component {
  render() {
    const {
      classes,
      orderSearchValue,
      proceedOrder,
      declineOrder,
      loading,
      searchOrders,
      openDeliveryDialog,
    } = this.props;

    const filterByTerm = (order) => {
      const searchTermMatch = caseInsensitiveMatch.bind(null, orderSearchValue);
      const matchCode = searchTermMatch(order.pickupCode);
      const matchName = searchTermMatch(order.pickupName);
      return matchCode || matchName;
    };

    const orderList = orderSearchValue ? this.props.orders.filter(filterByTerm) : this.props.orders;

    const orders = orderList.map(o =>
      (<Grid item xs={12} sm={6} md={4} lg={3} key={o.id}>
        <Order
          value={o}
          proceedOrder={proceedOrder}
          declineOrder={declineOrder}
          openDeliveryDialog={openDeliveryDialog}
        />
      </Grid>));

    const orderGrid = orders.length > 0
      ? (<Grid item container spacing={16} className={classes.grid}>
        {orders}
      </Grid>)
      : null;

    const loadingIndicator = loading
      ? <LinearProgress className={classes.loadingIndicator} />
      : null;

    const noEntriesFound = !loading && orders.length === 0
      ? (<div className={classes.noEntriesFound}>
        <NoEntriesIcon className={classes.noEntriesFoundIcon} />
        <Typography className={classes.noEntriesFoundText}>Alle Bestellungen abgearbeitet</Typography>
      </div>)
      : null;

    const rootStyle = noEntriesFound
      ? {
        alignItems: 'center',
        height: '100%',
        flexDirection: 'row',
      }
      : null;

    return (
      <Grid container item direction="column" style={rootStyle}>
        {loadingIndicator}
        {noEntriesFound}
        {orderGrid}
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
  },
  grid: {
    padding: 10,
  },
  noEntriesFound: {
    padding: 10,
    flexGrow: 1,
    textAlign: 'center',
  },
  noEntriesFoundText: {
    color: theme.palette.text.hint,
    fontSize: 16,
  },
  noEntriesFoundIcon: {
    color: theme.palette.text.secondary,
    fontSize: 150,
  },
  loadingIndicator: {
    width: '100%',
  },
});

OrderGrid.propTypes = {
  classes: PropTypes.object.isRequired,
  orders: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  proceedOrder: PropTypes.func.isRequired,
  declineOrder: PropTypes.func.isRequired,
  openDeliveryDialog: PropTypes.func.isRequired,
  orderSearchValue: PropTypes.string,
  searchOrders: PropTypes.array,
};

OrderGrid.defaultProps = {
  orderSearchValue: null,
  searchOrders: [],
};

export default withStyles(styles)(OrderGrid);
